<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NcaDaN/tc-custom/9780253037251.jpg?1713381591941" alt="This image is the cover for the book Elemental Discourses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elemental Discourses
      </h1>
      <p class="bookDescription body article font2">
        <b>“A remarkable collection of essays that serve as a rewarding introduction to the more mature thought of Sallis . . . a feast of discourse.” —<i>Notre Dame Philosophical Reviews</i></b><br/><br/>John Sallis’s thought is oriented to two overarching tasks: to bring to light the elemental in nature and to show how the imagination operates at the very center of human experience. He undertakes these tasks by analyzing a broad range of phenomena, including perception, the body, the natural world, art, space, and the cosmos. In every case, Sallis develops an original form of discourse attuned to the specific phenomenon and enacts a thorough reflection on discourse itself in its relation to voice, dialogue, poetry, and translation. Sallis’s systematic investigations are complemented by his extensive interpretations of canonical figures in the history of philosophy such as Plato, Aristotle, Kant, Schelling, and Hegel and by his engagement with the most original thinkers in the areas of phenomenology, hermeneutics, and deconstruction.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Sallis
      </h2>
      
      <p class="authorDescription body article"><P><P>John Sallis is Frederick J. Adelmann Professor of Philosophy at Boston College. He is author of more than 20 books, including <I>Light Traces</I>, <I>The Return of Nature</I>, and <I>The Figure of Nature</I>.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61d61527